import React, { useState } from 'react';
import { ArrowRight } from 'lucide-react';
import StepCard from '../components/StepCard';
import { workflowSteps, workflowSummary, pipelineStages } from '../data/workflowSteps';
import './ModelContextProtocol.css';

export const ModelContextProtocol = () => {
  const [expandedStep, setExpandedStep] = useState(null);

  const toggleStep = (step) => {
    setExpandedStep(expandedStep === step ? null : step);
  };

  return (
    <div className="mcp-page">
      {/* Page Header */}
      <div className="page-header">
        <div>
          <h1 className="page-title">AI Native Test Automation</h1>
          <p className="page-description">
            Azure DevOps Test Automation Workflow — end-to-end from user story analysis to automated test execution.
          </p>
        </div>
      </div>

      {/* Overview */}
      <section className="mcp-section">
        <div className="mcp-overview">
          <h2 className="mcp-overview-title">Overview</h2>
          <p>
            This documents the end-to-end test automation workflow implemented in the MCP-Demo project. 
            The workflow integrates with Azure DevOps and leverages Playwright for UI testing, providing a 
            comprehensive solution from user story analysis to automated test execution.
          </p>
        </div>
      </section>

      {/* Workflow Pipeline */}
      <section className="mcp-section">
        <ul className="mcp-pipeline" aria-label="Workflow pipeline">
          {pipelineStages.map((label, i) => (
            <React.Fragment key={label}>
              <li className="mcp-pipeline-step">{label}</li>
              {i < pipelineStages.length - 1 && <ArrowRight size={16} className="mcp-pipeline-arrow" />}
            </React.Fragment>
          ))}
        </ul>
      </section>

      {/* Workflow Steps */}
      <section className="mcp-section">
        {workflowSteps.map((step) => (
          <StepCard
            key={step.step}
            step={step}
            isExpanded={expandedStep === step.step}
            onToggle={() => toggleStep(step.step)}
          />
        ))}
      </section>

      {/* Workflow Summary */}
      <section className="mcp-section">
        <div className="mcp-summary">
          <h2 className="mcp-overview-title">Complete Workflow Summary</h2>
          <div className="mcp-summary-list">
            {workflowSummary.map((item, i) => (
              <div key={item} className="mcp-summary-item">
                <span className="mcp-summary-step">Step {i + 1}</span>
                <span>{item}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Video Section */}
      <section className="mcp-section">
        <div className="mcp-video-card">
          <h2 className="mcp-overview-title">MCP Overview Video</h2>
          <div className="mcp-video-embed">
            <iframe
            src="https://alaskaair-my.sharepoint.com/personal/prashant_katiyar_alaskaair_com/_layouts/15/embed.aspx?UniqueId=baa74dd2-05e5-4375-a984-fcf886d9d199&embed=%7B%22ust%22%3Afalse%2C%22hv%22%3A%22CopyEmbedCode%22%7D&referrer=StreamWebApp&referrerScenario=EmbedDialog.Create"
              width="640"
              height="360"
              frameBorder="0"
              scrolling="no"
              allowFullScreen
              title="MCP Demo Video"
              className="mcp-video-iframe"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default ModelContextProtocol;
